import React from 'react';

// Material UI
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

// Hooks
import useUser from '../../../hooks/user/useUser';
const UserStats = () => {
    const { branch, pv, cashRegister } = useUser();

    if(!branch || !pv || !cashRegister)
        return null;

    return (
        <>
            <Typography component='span' variant='body1'>
                <strong>{branch.code} / {pv.billingCode} / {cashRegister.name}</strong>
            </Typography>
            <Divider orientation="vertical" flexItem />
        </>
    )
}

export default UserStats;